import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { useLoadAvailablePaymentMethods } from '../hooks/useLoadAvailablePaymentMethods'

type TContextValue = ReturnType<typeof useLoadAvailablePaymentMethods>

const [
  Provider, //
  useAvailablePaymentMethodsCtx,
] = createContext<TContextValue>(`AvailablePaymentMethods`)

type TProps = RequiredChildren & {
  order: FirstParam<typeof useLoadAvailablePaymentMethods>
}

/**
 * Provides the context with available payment methods for the `order`.
 * - use `useAvailablePaymentMethodsCtx` to access the payment methods
 */
export const AvailablePaymentMethodsProvider: React.FC<TProps> = ({ children, order }) => {
  const contextValue = useLoadAvailablePaymentMethods(order)

  return <Provider value={contextValue}>{children}</Provider>
}

export { useAvailablePaymentMethodsCtx }
